
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import service from "@/assets/data/home/service.json";
import profileOverview from "@/assets/data/home/profileOverview.json";
import profileHistory from "@/assets/data/home/profileHistory.json";
import client from "@/assets/data/home/client.json";
import {formedgeLink, formedgeServicePageLink} from "@/functions/formedgeLink";

@Component
export default class HomeContent extends Vue {
  private services = service.contents;
  private overview = profileOverview.contents;
  private history = profileHistory.contents;
  private clients = client.contents;

  // ヒーロー下のスタッツ（会社の信頼を数字で端的に伝える）
  private stats = [
    {label: "設立", value: "2016", unit: "年"},
    {label: "メンバー", value: "23", unit: "名"},
    {label: "富士通戦略パートナー認定", value: "2022", unit: "年〜"},
    {label: "自社SaaS", value: "FormEdge", unit: ""},
  ];

  // 自社サービス FormEdge への外部リンク（流入元計測用の UTM 付き）
  private formedgeLink(content: string): string {
    return formedgeLink("top", content);
  }

  // FormEdge で作成・公開しているサービス紹介ページへのリンク（UTM 付き）
  private formedgeServicePageLink(content: string): string {
    return formedgeServicePageLink("top", content);
  }

  private scrollToServices(): void {
    const el = this.$refs.services as HTMLElement | undefined;
    el?.scrollIntoView({behavior: "smooth", block: "start"});
  }
}
